import { render, staticRenderFns } from "./rewardCooperateTreasureEdit.vue?vue&type=template&id=5a823b2b&scoped=true&"
import script from "./rewardCooperateTreasureEdit.vue?vue&type=script&lang=js&"
export * from "./rewardCooperateTreasureEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a823b2b",
  null
  
)

export default component.exports